export const OFF_WHITE = '#fbfbfb';
